import { forwardRef } from 'react'
import type { ComponentProps } from 'react'

import Input from '@components/common/Input/Input'

import { PiEnvelopeSimple } from 'react-icons/pi'

type EmailInputProps = Omit<ComponentProps<typeof Input>, 'type' | 'prefix'>

export const EmailInput = forwardRef<HTMLInputElement, EmailInputProps>((props, ref) => {
  return (
    <Input
      {...props}
      ref={ref}
      type="email"
      prefix={
        <PiEnvelopeSimple
          className="absolute top-4 left-4 text-zinc-500 w-5 h-5"
        />
      }
      className={`pl-12 ${props['className']}`}
    />
  )
})

EmailInput.displayName = 'EmailInput'

export default EmailInput